(function () {
  function formatMoney(cents) {
    var fmt = window.MW_MONEY_FORMAT || '${{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, fmt);
    }
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function safeJSON(el) {
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  function getLabelForInput(root, input) {
    if (input.id) {
      var esc = (window.CSS && CSS.escape) ? CSS.escape(input.id) : input.id;
      var lbl = root.querySelector('label[for="' + esc + '"]');
      if (lbl) return lbl;
    }
    if (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') return input.nextElementSibling;
    var up = input.closest && input.closest('label');
    if (up) return up;
    return null;
  }

  function readSelectionsByFieldset(root, optionCount) {
    var sel = new Array(optionCount).fill('');

    var fieldsets = root.querySelectorAll('fieldset');
    if (fieldsets.length) {
      fieldsets.forEach(function (fs, idx) {
        if (idx >= optionCount) return;
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) sel[idx] = checked.value;
      });
    }

    var selects = root.querySelectorAll('select[name]');
    selects.forEach(function (s, idx) {
      if (idx >= optionCount) return;
      if (s.value) sel[idx] = s.value;
    });

    return sel;
  }

  function matchesSelection(v, sel) {
    var vo = v.options || [];
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] && vo[i] !== sel[i]) return false;
    }
    return true;
  }

  function findVariantFor(variants, sel) {
    var firstMatch = null;
    var firstAvailable = null;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!matchesSelection(v, sel)) continue;
      if (!firstMatch) firstMatch = v;
      if (v.available && !firstAvailable) firstAvailable = v;
      if (firstAvailable) break;
    }
    return firstAvailable || firstMatch;
  }

  // Wrap leading "1/48", "1/144", "1/100", etc. in <span class="mw-scale">…</span>
  function ensureScaleWrapped(labelEl) {
    if (!labelEl || labelEl.querySelector('.mw-scale')) return;

    // Find the first non-empty text node inside the label
    var walker = document.createTreeWalker(labelEl, NodeFilter.SHOW_TEXT, null);
    var textNode = null;
    while (walker.nextNode()) {
      var t = walker.currentNode;
      if (t && t.nodeValue && t.nodeValue.trim()) { textNode = t; break; }
    }
    if (!textNode) return;

    var txt = textNode.nodeValue;

    // Match scale at the start of that text node
    var m = txt.match(/^\s*(1\/\d+)\b/);
    if (!m) return;

    var scale = m[1];
    var scalePos = txt.indexOf(scale);

    var before = txt.slice(0, scalePos);
    var after = txt.slice(scalePos + scale.length);

    var frag = document.createDocumentFragment();
    if (before) frag.appendChild(document.createTextNode(before));

    var span = document.createElement('span');
    span.className = 'mw-scale';
    span.textContent = scale;
    frag.appendChild(span);

    if (after) frag.appendChild(document.createTextNode(after));

    // Replace the original text node with the fragment
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function applyToPicker(pickerRoot) {
    var vTag = pickerRoot.querySelector('script[data-mw-variants]');
    var oTag = pickerRoot.querySelector('script[data-mw-option-names]');
    if (!vTag || !oTag) return;

    var variants = safeJSON(vTag) || [];
    var optionNames = safeJSON(oTag) || [];
    var optionCount = Math.max(optionNames.length, 1);
    if (!variants.length) return;

    var current = readSelectionsByFieldset(pickerRoot, optionCount);

    var radios = pickerRoot.querySelectorAll('input[type="radio"][name]');
    if (!radios.length) return;

    radios.forEach(function (r) {
      var fs = r.closest('fieldset');
      var idx = 0;

      if (fs) {
        var allFs = Array.prototype.slice.call(pickerRoot.querySelectorAll('fieldset'));
        idx = allFs.indexOf(fs);
        if (idx < 0) idx = 0;
        if (idx >= optionCount) idx = optionCount - 1;
      }

      var host = getLabelForInput(pickerRoot, r);
      if (!host) return;

      var candidate = current.slice();
      candidate[idx] = r.value;

      var v = findVariantFor(variants, candidate);
      if (!v) {
        host.removeAttribute('data-mw-price');
        return;
      }

      host.setAttribute('data-mw-price', formatMoney(v.price));
      ensureScaleWrapped(host); // <-- this is the actual fix
    });
  }

  var scheduled = false;
  function scan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      document.querySelectorAll('[data-mw-vpp]').forEach(applyToPicker);
    });
  }

  function burst() {
    scan();
    setTimeout(scan, 50);
    setTimeout(scan, 150);
    setTimeout(scan, 300);
  }

  document.addEventListener('DOMContentLoaded', scan);

  // Dawn / theme editor hooks
  document.addEventListener('shopify:section:load', burst);
  document.addEventListener('shopify:section:select', burst);

  // Re-apply after user actions that trigger Dawn rerenders
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches && (t.matches('input[type="radio"]') || t.matches('select'))) burst();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest('[data-mw-vpp]')) burst();
  }, true);

  // Lightweight observer: catches Dawn DOM swaps
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'childList' && (muts[i].addedNodes.length || muts[i].removedNodes.length)) {
          scan();
          break;
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
